'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reduxFireDispatcher = undefined;

var _reduxFireDispatcher;

var _actions = require('./actions');

var _entityUpdate = require('./entityUpdate');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var reduxFireDispatcher = exports.reduxFireDispatcher = (_reduxFireDispatcher = {}, _defineProperty(_reduxFireDispatcher, _actions.CREATE_LIST, _entityUpdate.createList), _defineProperty(_reduxFireDispatcher, _actions.CREATE_ITEM, _entityUpdate.createItem), _defineProperty(_reduxFireDispatcher, _actions.UPDATE_ITEM, _entityUpdate.updateItem), _reduxFireDispatcher);